var $db553ffe17c7f4db$exports = {};
$db553ffe17c7f4db$exports = {
  "calendar": `Kalender`,
  "day": `p\xe4ev`,
  "dayPeriod": `enne/p\xe4rast l\xf5unat`,
  "endDate": `L\xf5ppkuup\xe4ev`,
  "era": `ajastu`,
  "hour": `tund`,
  "minute": `minut`,
  "month": `kuu`,
  "second": `sekund`,
  "selectedDateDescription": args => `Valitud kuup\xe4ev: ${args.date}`,
  "selectedRangeDescription": args => `Valitud vahemik: ${args.startDate} kuni ${args.endDate}`,
  "selectedTimeDescription": args => `Valitud aeg: ${args.time}`,
  "startDate": `Alguskuup\xe4ev`,
  "timeZoneName": `ajav\xf6\xf6nd`,
  "weekday": `n\xe4dalap\xe4ev`,
  "year": `aasta`
};
export { $db553ffe17c7f4db$exports as default };